import * as types from './types';
import * as filesActions from 'services/api/files';
import { uiActions } from 'state/modules/UI';
import i18n from 'i18n-js';
import { getErrorMessage, parsePagination } from 'utils';

// Get images
const fetchImagesRequest = () => ({
  type: types.FETCH_IMAGES_REQUEST,
});

const fetchImagesSuccess = (payload) => ({
  type: types.FETCH_IMAGES_SUCCESS,
  payload,
});

const fetchImagesFailed = (error) => ({
  type: types.FETCH_IMAGES_FAILED,
  error,
});

export const fetchImages = (params) => {
  return async (dispatch) => {
    dispatch(fetchImagesRequest());

    const response = await filesActions.fetchImages(params);

    if (response.ok) {
      const pagination = parsePagination(response.headers);
      return dispatch(
        fetchImagesSuccess({
          pagination: pagination,
          data: response.data,
          type: params.source_type,
        })
      );
    }

    const error = getErrorMessage(response.data);

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );

    dispatch(fetchImagesFailed(error));
  };
};
// Update File
const fetchUpdateImageRequest = () => ({
  type: types.FETCH_UPDATE_IMAGE_REQUEST,
});

const fetchUpdateImageSuccess = (payload) => ({
  type: types.FETCH_UPDATE_IMAGE_SUCCESS,
  payload,
});

const fetchUpdateImageFailed = (error) => ({
  type: types.FETCH_UPDATE_IMAGE_FAILED,
  error,
});

export const fetchUpdateImage = (payload) => {
  return async (dispatch) => {
    dispatch(fetchUpdateImageRequest());

    const response = await filesActions.updateImage(payload);

    if (response.ok) {
      const pagination = parsePagination(response.headers);
      return dispatch(
        fetchUpdateImageSuccess({
          pagination: pagination,
          data: response.data,
        })
      );
    }

    const error = getErrorMessage(response.data);

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );

    dispatch(fetchUpdateImageFailed(error));
  };
};
// Upload Image
const fetchUploadImageRequest = () => ({
  type: types.FETCH_UPLOAD_IMAGE_REQUEST,
});

const fetchUploadImageSuccess = (payload) => ({
  type: types.FETCH_UPLOAD_IMAGE_SUCCESS,
  payload,
});

const fetchUploadImageFailed = (error) => ({
  type: types.FETCH_UPLOAD_IMAGE_FAILED,
  error,
});

export const fetchUploadImage = (payload) => {
  return async (dispatch) => {
    dispatch(fetchUploadImageRequest());

    const response = await filesActions.uploadImage(payload);

    if (response.ok) {
      const pagination = parsePagination(response.headers);
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'success',
          message: i18n.t('common.image_upload_success'),
        })
      );
      return dispatch(
        fetchUploadImageSuccess({
          pagination: pagination,
          data: response.data,
        })
      );
    }

    const error = getErrorMessage(response.data);

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );

    dispatch(fetchUploadImageFailed(error));
  };
};
// Delete File
const fetchDeleteImageRequest = () => ({
  type: types.FETCH_DELETE_IMAGE_REQUEST,
});

const fetchDeleteImageSuccess = (payload) => ({
  type: types.FETCH_DELETE_IMAGE_SUCCESS,
  payload,
});

const fetchDeleteImageFailed = (error) => ({
  type: types.FETCH_DELETE_IMAGE_FAILED,
  error,
});

export const fetchDeleteImage = (payload) => {
  return async (dispatch) => {
    dispatch(fetchDeleteImageRequest());

    const response = await filesActions.deleteImage(payload);

    if (response.status === 200 || response.status === 204) {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'success',
          message: `${payload?.image_id?.length > 1 ? 'Images' : 'Image'} deleted successfully`,
        })
      );
      return dispatch(
        fetchDeleteImageSuccess({
          data: response.data,
        })
      );
    }

    const error = getErrorMessage(response.data);

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );

    dispatch(fetchDeleteImageFailed(error));
  };
};

// Reset upload vehicle type image
export const resetUploadFileSuccess = (payload) => ({
  type: types.RESET_UPLOAD_IMAGE_SUCCESS,
  payload,
});
